import axios from "axios";
import config from '../../config';

const BASE_URL = config.apiUrl;

const GetlisteReservation = async () => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
        },
    };

    const instance = axios.create(options);
    try {
        const response = await instance.get("/rabat-zoo/reservation/api/getListReservation");
        return response.data;
    } catch (error) {
        throw error.response;
    }
};

const calculateConferenceReservations = async (dataPost) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
        },
    };

    const instance = axios.create(options);

    try {
        const response = await instance.put("/rabat-zoo/reservation/api/add", dataPost);
        return response.data; // Retourner les données du serveur
    } catch (error) {
        throw error.response; // Gérer les erreurs
    }
};

const AddPageReservation = async (DataPost) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
        },
    };

    const instance = axios.create(options);

    try {
        const response = await instance.post("/rabat-zoo/page-reservation/api/add", DataPost);
        return response;
    } catch (error) {
        throw error.response;
    }
};

const updatePageReservation = async (DataPost) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
        },
    };

    const instance = axios.create(options);

    try {
        const response = await instance.put("/rabat-zoo/page-reservation/api/update", DataPost);
        return response;
    } catch (error) {
        throw error.response;
    }
};

const disablePageReservation = async (id) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
        },
    };

    const instance = axios.create(options);

    try {
        const response = await instance.get("/rabat-zoo/page-reservation/api/disable/" + id);
        return response;
    } catch (error) {
        throw error.response;
    }
};

const enablepageReservation = async (id) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
        },
    };

    const instance = axios.create(options);

    try {
        const response = await instance.get("/rabat-zoo/page-reservation/api/enable/" + id);
        return response;
    } catch (error) {
        throw error.response;
    }
};

const UploadFilePageReservation = async (formData) => {
    const options = {
        baseURL: BASE_URL,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };

    const instance = axios.create(options);
    try {
        const response = await instance.post("/rabat-zoo/page-reservation/api/upload", formData);
        return response.data;
    } catch (error) {
        throw error.response;
    }
};
const plus_populaires = async (DataPost) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
        },
    };

    const instance = axios.create(options);

    try {
        const response = await instance.get("/rabat-zoo/animal/api/top-ten", DataPost);
        return response;
    } catch (error) {
        throw error.response;
    }
};

const getTotalDownloads = async () => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
        },
    };

    const instance = axios.create(options);
    try {
        const [inviteResponse, utilisateurResponse] = await Promise.all([
            instance.get("/rabat-zoo/invite/api/all"),
            instance.get("/rabat-zoo/utilisateur/api/getListUtilisateur"),
        ]);
        
        const totalDownloads = inviteResponse.data.length + utilisateurResponse.data.length;
        return totalDownloads;
    } catch (error) {
        throw error.response;
    }
};

const getDownloadsThisWeek = async () => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
        },
    };

    const instance = axios.create(options);
    try {
        const [inviteResponse, utilisateurResponse] = await Promise.all([
            instance.get("/rabat-zoo/invite/api/all"),
            instance.get("/rabat-zoo/utilisateur/api/getListUtilisateur"),
        ]);

        // Get the current week's start date (e.g., Monday)
        const today = new Date();
        const firstDayOfWeek = today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1);
        const startOfWeek = new Date(today.setDate(firstDayOfWeek));

        // Filter records by `createAt` date
        const isThisWeek = (dateStr) => new Date(dateStr) >= startOfWeek;

        const inviteThisWeek = inviteResponse.data.filter(item => isThisWeek(item.createAt));
        const utilisateurThisWeek = utilisateurResponse.data.filter(item => isThisWeek(item.createAt));

        const downloadsThisWeek = inviteThisWeek.length + utilisateurThisWeek.length;
        return downloadsThisWeek;
    } catch (error) {
        throw error.response;
    }
};

export {
    GetlisteReservation,
    AddPageReservation,
    updatePageReservation,
    disablePageReservation,
    enablepageReservation,
    UploadFilePageReservation,
    calculateConferenceReservations,
    plus_populaires,
    getTotalDownloads,
    getDownloadsThisWeek,
};

